export interface Device {
  id: string;
  active: boolean;
  deviceId: string;
  deviceName: string;
  deviceModel: string;
  userId: string;
  clientCode: string;
  createdDate: string;
  modificationDate: string;
  type?: DeviceType;
}

export type DeviceType = 'phone' | 'tablet' | 'pc';

export const VISITOR_ID = 'Visitor-Id';
export const MAX_ACTIVE_DEVICES_ALLOWED = 6;
